import { render, staticRenderFns } from "./PreguntasTableIngresados.vue?vue&type=template&id=4f783b5c"
import script from "./PreguntasTableIngresados.vue?vue&type=script&lang=js"
export * from "./PreguntasTableIngresados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports